import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const policyPlugin = createPlugin({
  id: 'policy',
  routes: {
    root: rootRouteRef,
  },
});

export const PolicyPage = policyPlugin.provide(
  createRoutableExtension({
    name: 'PolicyPage',
    component: () => import('./components/PolicyPage').then(m => m.PolicyPage),
    mountPoint: rootRouteRef,
  }),
);
